<div style="overflow-y: scroll; max-height: 600px;">
    <div class="row">
        <div class="col-lg-12" [formGroup]="customerStatusGroup">
            <epi-container [header]="customer.name + ' - Customer Status'">
                <mat-horizontal-stepper #stepper>
                    <div *ngIf="customerStatuses.length > 0 && customerStatusChecklists.length > 0">
                        <mat-step *ngFor="let status of customerStatuses" formGroupName="{{status.abbreviation}}">
                            <ng-template matStepLabel>{{status.description}}</ng-template>

                            <h3 class="text-center">{{status.description}}</h3>

                            <div>
                                <ul>
                                    <li *ngFor="let checklist of currentChecklist">
                                        <div *ngIf="customerStatusGroup.controls[status.abbreviation] != null &&
                                     customerStatusGroup.controls[status.abbreviation].controls[checklist.stage + 'Checkbox'] != null">
                                            <mat-checkbox formControlName="{{checklist.stage}}Checkbox" required
                                                          (change)="saveChecklistMap(checklist)"
                                                          [disabled]="isCRMAdmin!=true && status.description == 'Customer'">{{checklist.description}}</mat-checkbox>
                                            <span>{{getCompletedChecklistTimestamp(checklist)}}</span>
                                            <textarea formControlName="{{checklist.stage}}Text" class="form-control" rows="3" cols="50" placeholder="Enter Notes..." style="display: block; max-width: 500px;"
                                                      (focusout)="saveChecklistMap(checklist)"
                                                      [attr.disabled]="(isCRMAdmin!=true && status.description == 'Customer') ? '' : null"></textarea>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            <div class="col-lg-12">
                                <button class="epi-button" mat-button matStepperPrevious>Back</button>
                                <button class="epi-button" mat-button matStepperNext style="float: right; margin: 5px;">Next</button>
                            </div>
                        </mat-step>
                    </div>
                </mat-horizontal-stepper>
            </epi-container>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <epi-container [header]="'Add Action'">
                <add-customer-action [customerId]="selectedCustomerId" [customerActionId]="customerActionId"></add-customer-action>
            </epi-container>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <customer-action-grid [customerID]="selectedCustomerId"></customer-action-grid>
        </div>
    </div>
</div>
